import { useEffect } from 'react'
import { SocketMessage } from '../types/messaging'
import { SystemControl } from '../classes/SystemControl'

/**
 * Set the filter deciding if the screen needs refresh or not after receiving a socket message.
 */
export function useRefresh(filter: (s: SocketMessage) => boolean): void {
  useEffect(() => {
    const old = SystemControl.setRefreshFilter(filter)
    return () => {
      SystemControl.setRefreshFilter(old)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])
}

/**
 * Disable message based refresh for this page.
 */
export function useNoRefresh(): void {
  useRefresh(() => false)
}
